import gql from 'graphql-tag';

export const getContactOrgPartnerType = gql`
  query ContractsByOrg($where: ContractWhereInput!) {
    contracts(where: $where) {
      partnerType
      BillingAccount {
        id
        Contacts {
          id
          email
          receiveInvoices
        }
      }
    }
  }
`;
